import type { FC } from "react";
import type { IconCommonProps } from "@/icons/shared.ts";

export const IconDollar: FC<IconCommonProps> = ({ width, height, color }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width={width ?? 24}
      height={height ?? 24}
      fill="none"
      stroke={color ?? "#000000"}
      strokeWidth="1"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <circle cx="12" cy="12" r="10" />
      <path d="M16 8h-6a2 2 0 1 0 0 4h4a2 2 0 1 1 0 4H8m4 2V6" />
    </svg>
  );
};
